import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const List = lazy(() => import('./List'));
const SignalAddEditFormContainer = lazy(() => import('./SignalAddEditForm'));
const PackageAddEditFormContainer = lazy(() => import('./PackageAddEditForm'));
const WorkflowCreateFormContainer = lazy(() => import('./WorkflowCreateForm'));
const Import = lazy(() => import('./Import'));

export const ComponentsRoutes = () => {
    return (
        <Routes>
            <Route path="/components" element={<List />} />
            <Route path="/components/signal/:name" element={<SignalAddEditFormContainer />} />
            <Route path="/components/signal" element={<SignalAddEditFormContainer />} />

            <Route path="/components/package/:name" element={<PackageAddEditFormContainer />} />
            <Route path="/components/package" element={<PackageAddEditFormContainer />} />

            <Route path="/components/workflow" element={<WorkflowCreateFormContainer />} />

            <Route path="/components/import" element={<Import />} />

            <Route path="*" element={null} />
        </Routes>
    );
};
